<script setup lang="ts">
defineProps({
  isLoading: {
    type: Boolean,
    default: false
  }
});

</script>

<template>
  <div class="w-full border-2 border-onboard-shade2 py-3 rounded-xl relative cursor-pointer">
    <div class="absolute top-0 bottom-0 right-0 left-0 m-auto max-w-[50%] text-center">
      <div class="flex h-full items-center justify-center">
        <span v-if="!isLoading" class="leading-tight"><slot></slot></span>
        <span v-else>
          <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
        </span>
      </div>
    </div>

    <div class="flex flex-row h-full justify-between items-center px-6">
      <slot name="iconLeft"></slot>
      <slot name="iconRight"></slot>
    </div>
  </div>
</template>

<style scoped>
.lds-ring {
  display: inline-block;
  position: relative;
  width: 30px;
  height: 30px;
}
.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 24px;
  height: 24px;
  margin: 8px;
  border: 3px solid #fff;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #fff transparent transparent transparent;
}
.lds-ring div:nth-child(1) {
  animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
  animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
  animation-delay: -0.15s;
}
@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
